<template>
  <v-dialog
    v-model="show_agenda_modal"
    max-width="1200"
    @click:outside="closePopup"
  >
    <v-card>
      <iframe :src="agendaLink" frameborder="0" style="width:100%;height:85vh"></iframe>
      <v-btn style="position:absolute;bottom:20px;left:20px" color="red" dark fab small @click="closePopup">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <!-- <v-toolbar dark flat color="primary" dense>
        <v-toolbar-title>Agenda</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closePopup">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card flat>
            <v-card-text>
              <v-list>
                <div v-for="(item, index) in agenda_list" :key="index">
                  <v-list-item>
                    <span class="col-3">{{ getTimeSlot(item.session) }} (UTC)</span>
                    <v-btn color="primary" :to="'/session/'+item.session.session_id" target="_blank">
                      View
                    </v-btn>
                    <v-list-item-content class="mx-4">
                      <v-list-item-title>{{item.session.title}}</v-list-item-title>
                    </v-list-item-content>
                    <v-btn icon @click="addEvent(item.session.session_id)">
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-btn>
                  </v-list-item>
                  <v-divider
                    v-if="index != agenda_list.length - 1"
                  ></v-divider>
                </div>
                <div v-if="agenda_list.length == 0">
                  No Agenda Found!
                </div>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->
    </v-card>
  </v-dialog>
</template>
<script>
import axios from "@/helper/axios";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "AgendaPopup",
  data() {
    return {
      selected : []
    };
  },
  watch: {
    show_aganda_modal(value) {
      if (value) {
        this.fetchAgenda();
      }
    },
  },
  computed: {
    ...mapState("agenda", ["show_agenda_modal", "agenda_list"]),
    agendaLink(){
      // return process.env.VUE_APP_ASSETS + 'FLAACOs 2021 Fall Virtual Conference.pdf'
      return 'https://flaacos.com/2021-agenda/'
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    ...mapActions("agenda", ["fetchAgenda"]),
    ...mapMutations("agenda", ["setAgendaData"]),
    closePopup() {
      this.setAgendaData({
        key: "show_agenda_modal",
        data: false,
      });
    },
    getTimeSlot(session) {
      return (
        this.moment(session.start_time).format("ddd, MMM Do h:mm a") +
        " - " +
        this.moment(session.end_time).format("h:mm a")
      );
    },
    addEvent(session_id) {
      let _self = this;
      this.loading = "secondary";
      axios.post(`session/add_event`, {session_id:session_id})
        .then((response) => {
          let response_data = response.data;
          if (response_data.status) {
            _self.setAlert({
              show: true,
              variant: "success",
              message: response_data.message,
              dismissCountDown: 5000,
            });
          }
          else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.setAlert({
                show: true,
                variant: "danger",
                message: errors[key].message,
                dismissCountDown: 5000,
              });
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    }
  },
  mounted: function () {
    // this.fetchAgenda();
  },
};
</script>